export function formatDate(stringDate) {
  var d = new Date(stringDate);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function reverseHex(s) {
  const isValidHex = /^[0-9a-fA-F]*$/.test(s);
  if (!isValidHex || s.length % 2 !== 0) {
    return 'Invalid hex';
  }
  let reversed = '';
  for (let i = s.length - 2; i >= 0; i -= 2) {
    reversed += s.substr(i, 2);
  }
  return reversed;
};
